import { AxiosInstance, AxiosResponse } from 'axios'

import {
  SubdelegatedCheckResponse,
  SubdelegatedRegistrationPayload,
  SubdelegatedRegistrationResponse
} from 'models/interface/subdelegated'

export const subdelegatedClient = (httpInstance: AxiosInstance) => ({
  checkInvite: async (code: string): Promise<AxiosResponse<SubdelegatedCheckResponse>> =>
    await httpInstance.get('/api/substabelecido/check', { params: { code } }),
  submitRegistration: async (
    code: string,
    payload: SubdelegatedRegistrationPayload
  ): Promise<AxiosResponse<SubdelegatedRegistrationResponse>> =>
    await httpInstance.post('/api/substabelecido', payload, { params: { code } })
})
